export function LegalDocumentPage({ document }) {
  return (
    <main className="min-h-[calc(100vh-4rem)] bg-white" data-testid="legal-document-page">
      <div className="mx-auto max-w-4xl px-6 py-16 lg:px-10 lg:py-20">
        <header className="border-b border-neutral-200 pb-10">
          <p className="eyebrow mb-3">Legal & Customer Support</p>
          <h1
            className="font-display text-4xl font-bold tracking-tight sm:text-5xl"
            data-testid="legal-page-title"
          >
            {document.title}
          </h1>
          {document.effectiveDate && (
            <p className="mt-4 text-sm text-neutral-500" data-testid="legal-effective-date">
              Effective Date: {document.effectiveDate}
            </p>
          )}
          {document.intro && (
            <p className="mt-6 max-w-3xl leading-relaxed text-neutral-600">{document.intro}</p>
          )}
        </header>
        <div className="space-y-10 pt-10">
          {document.sections.map((section) => (
            <section key={section.heading} data-testid={`legal-section-${section.heading.slice(0, 1)}`}>
              <h2 className="font-display text-2xl font-bold tracking-tight">{section.heading}</h2>
              {section.lead && <p className="mt-3 leading-relaxed text-neutral-700">{section.lead}</p>}
              {section.paragraphs?.map((paragraph) => (
                <p key={paragraph} className="mt-3 leading-relaxed text-neutral-700">{paragraph}</p>
              ))}
              {section.bullets && (
                <ul className="mt-3 list-disc space-y-2 pl-5 leading-relaxed text-neutral-700">
                  {section.bullets.map((bullet) => <li key={bullet}>{bullet}</li>)}
                </ul>
              )}
            </section>
          ))}
        </div>
      </div>
    </main>
  );
}